// extracted by mini-css-extract-plugin
export const card = "styles-module--card--+uIZw";
export const btn = "styles-module--btn--kPha1";
export const btnGet = "styles-module--btnGet--fhdUw";
export const txtTitle = "styles-module--txtTitle--fGzjw";
export const txtDes = "styles-module--txtDes--oqLiE";
export const txtHelper = "styles-module--txtHelper--tcSbf";